import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({location}) => {
	return(
		<div className={
			location
			? 'footer footer_light'
			: 'footer'
		}>
		<span className="footer_links "><Link to={'/about'}>About</Link> &middot; <Link to={'/premium'}>Premium</Link> &middot; <Link to={'/contact'}>Contact Us</Link> &middot; <Link to={'/terms'}>Terms & Conditions</Link> &middot; <Link to={'/privacy-policy'}>Privacy Policy</Link></span>
		<div className="foot_link">
		<a href="https://twitter.com/ViewwApp" target="_blank" alt="ViewwApp Twitter"><span className="fa fa-twitter foot"/></a>
		<a href="https://instagram.com/viewwapp" target="_blank" alt="ViewwApp Instagram"><span className="fa fa-instagram foot"/></a>
		</div>
		Copyright &copy; 2019 <strong>Vieww</strong>
		</div>
		)
}

export default Footer